export enum RouteType {
  MAIN_ROUTE = "mainRoute",
  SUB_ROUTE = "subRoute",
}

export enum Url {
  AC = "/ac",
  AC_VEHICLE_TOWED = "/ac/towed",
  AC_VEHICLE = "/ac/vehicle",
  AC_APPLICANT = "/ac/applicant",
  AC_APPLICANT_DATA = "/ac/applicant/applicant",
  AC_APPLICANT_DRIVER = "/ac/applicant/driver",
  AC_APPLICANT_ADDITIONAL = "/ac/applicant/additional",
  AC_INCIDENT = "/ac/incident",
  AC_INCIDENT_CIRCUMSTANCES = "/ac/incident/circumstances",
  AC_INCIDENT_DAMAGES = "/ac/incident/damages",
  AC_INCIDENT_STATEMENTS = "/ac/incident/statements",
  AC_PERPETRATOR = "/ac/perpetrator",
  AC_SUMMARY = "/ac/summary",
  AC_SENDING = "/ac/sending",
  AC_SENDING_SUCCESS = "/ac/sending-success",
  OC_PROPERTY = "/oc-property",
  OC_PROPERTY_PERPETRATOR = "/oc-property/perpetrator",
  OC_PROPERTY_INCIDENT = "/oc-property/incident",
  OC_PROPERTY_INCIDENT_CIRCUMSTANCES = "/oc-property/incident/circumstances",
  OC_PROPERTY_INCIDENT_STATEMENTS = "/oc-property/incident/statements",
  OC_PROPERTY_INCIDENT_OTHER_PERSONS = "/oc-property/incident/other-persons",
  OC_PROPERTY_OWNER = "/oc-property/owner",
  OC_PROPERTY_DAMAGES = "/oc-property/damages",
  OC_PROPERTY_SUMMARY = "/oc-property/summary",
  OC_PROPERTY_SENDING = "/oc-property/sending",
  OC_PROPERTY_SENDING_SUCCESS = "/oc-property/sending-success",
  OC_PERSON = "/oc-person",
  OC_VEHICLE = "/oc-vehicle",
  OC_VEHICLE_INTRODUCTORY = "/oc-vehicle/introductory",
  OC_VEHICLE_INTRODUCTORY_PERPETRATOR = "/oc-vehicle/introductory/perpetrator",
  OC_VEHICLE_INTRODUCTORY_APPLICANT = "/oc-vehicle/introductory/applicant",
  OC_VEHICLE_INCIDENT = "/oc-vehicle/incident",
  OC_VEHICLE_INCIDENT_CIRCUMSTANCES = "/oc-vehicle/incident/circumstances",
  OC_VEHICLE_INCIDENT_STATEMENTS = "/oc-vehicle/incident/statements",
  OC_VEHICLE_INCIDENT_OTHER_PERSONS = "/oc-vehicle/incident/other-persons",
  OC_VEHICLE_INCIDENT_WITNESSES = "/oc-vehicle/incident/witnesses",
  OC_VEHICLE_VEHICLE_OWNER = "/oc-vehicle/vehicle-owner",
  OC_VEHICLE_VEHICLE_OWNER_VEHICLE = "/oc-vehicle/vehicle-owner/vehicle",
  OC_VEHICLE_DAMAGES = "/oc-vehicle/damages",
  OC_VEHICLE_DAMAGES_IMAGES_DESCRIPTION = "/oc-vehicle/damages/images-description",
  OC_VEHICLE_DAMAGES_ADDITIONAL = "/oc-vehicle/damages/additional",
  OC_VEHICLE_SUMMARY = "/oc-vehicle/summary",
  OC_VEHICLE_SENDING = "/oc-vehicle/sending",
  OC_VEHICLE_SENDING_SUCCESS = "/oc-vehicle/sending-success",
  WELCOME = "/",
  SENDING_ERROR = "/sending-error",
}

export enum Page {
  EMPTY = "",
  GENERIC_PRELOAD = "preload",
  WELCOME = "welcome",
  AC_VEHICLE = "vehicle",
  AC_APPLICANT = "applicant",
  AC_INCIDENT = "incident",
  AC_PERPETRATOR = "perpetrator",
  AC_SUMMARY = "summary",
  OC_VEHICLE_INTRODUCTORY = "oc_vehicle_introductory",
  OC_VEHICLE_INCIDENT = "oc_vehicle_incident",
  OC_VEHICLE_VEHICLE_OWNER = "oc_vehicle_vehicle_owner",
  OC_VEHICLE_DAMAGES = "oc_vehicle_damages",
  OC_VEHICLE_SUMMARY = "oc_vehicle_summary",
  OC_PROPERTY_PERPETRATOR = "oc_property_perpetrator",
  OC_PROPERTY_INCIDENT = "oc_property_incident",
  OC_PROPERTY_OWNER = "oc_property_owner",
  OC_PROPERTY_DAMAGES = "oc_property_damages",
  OC_PROPERTY_SUMMARY = "oc_property_summary",
}
